import { render, staticRenderFns } from "./MoveNumber.vue?vue&type=template&id=3bb96212&scoped=true"
import script from "./MoveNumber.vue?vue&type=script&lang=js"
export * from "./MoveNumber.vue?vue&type=script&lang=js"
import style0 from "./MoveNumber.vue?vue&type=style&index=0&id=3bb96212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb96212",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmFieldPhone: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmFieldPhone.vue').default,TlmCheckoutSecretNumber: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmCheckoutSecretNumber.vue').default,TlmFieldSim: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmFieldSim.vue').default,ModalFindSimCard: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Modal/FindSimCard.vue').default,TlmCheckoutCurrentSimTypeSelector: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/CurrentSimTypeSelector.vue').default,TlmCheckoutSimSelector: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/SimSelector.vue').default,TlmCheckoutContinueBtn: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/TlmCheckoutContinueBtn.vue').default})
